import { Button, Col, Input, Row, RowProps } from "antd";
import styles from "../Interactive.module.scss";
import { useState } from "react";
import { InputForm } from "./InputForm";
import { InteractiveBlockComponent } from "..";
import { DialogBoxFooter } from "components/Scenario";
import { frontendAjaxCall } from "api/hooks";
import { Buttons } from "./Buttons";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import i18n from "i18next";
import { suspendedLazy } from "utils/suspended";
import { Loader } from "components/Loader";

const ScenarioFormItem = suspendedLazy(
  () =>
    import("./ScenarioFormItem").then(
      ({ ScenarioFormItem }) => ScenarioFormItem
    ),
  Loader({ mode: "keyboard" })
);

const AuthServices = ({
  onAuthClick,
  ...props
}: RowProps & { onAuthClick?: (service: string) => void }) => (
  <Row {...props}>
    {[
      // {
      //   service: "facebook",
      //   src: FacebookLogo,
      //   url: FRONTEND_DOMAIN + `/auth/facebook`,
      // },
      // {
      //   service: "googlePlus",
      //   src: GoogleLogo,
      //   url: FRONTEND_DOMAIN + "/auth/google",
      // },
      // {
      //   service: "apple",
      //   src: AppleLogo,
      //   style: { filter: "invert(1)" },
      //   url: FRONTEND_DOMAIN + "/auth/apple",
      // },
      // @ts-ignore
    ].map(({ service, src, url, style }, i) => (
      <Col key={i}>
        <Button
          style={{
            border: "none",
            padding: 0,
          }}
          type="text"
          icon={
            <img
              className={styles.authServiceButtonIcon}
              src={src}
              style={style}
              alt="logo"
            />
          }
          onClick={() => {
            onAuthClick?.(service);
            window.top?.location.assign(url); // aka redirect
          }}
        />
      </Col>
    ))}
  </Row>
);

const Auth = ({
  onBack,
  onChange,
  onAuth,
  mobile,
  authServices = false,
  contrastGrayscale,
}: Parameters<InteractiveBlockComponent>[0] & {
  authServices?: boolean;
  onAuth: (authed: any, phone: string) => Promise<void>;
}) => {
  const [authVariant, setAuthVariant] = useState<"password" | "code" | null>(null);
  const [phone, setPhone] = useState<string>();
  const [userChecked, setUserChecked] = useState<string>();

  const sendCode = async (phone: string, channel?: "sms" | "viber") => {
    await frontendAjaxCall("/auth/web/sms", { body: { phone, via: channel } });
  };
  const verifyCode = async (phone: string, sms_code: string) => {
    const res = await frontendAjaxCall("/auth/web/sms/check", {
      body: { phone, sms_code },
    });
    if (!res.status) throw new Error("wrong code");
    return res.data.id;
  };

  const authPassword = async (phone: string, password: string) => {
    if (userChecked === "noUser")
      await frontendAjaxCall("auth/password/change", {
        body: { phone, password },
      });

    const res = await frontendAjaxCall("/auth/password/password/check", {
      body: { phone, password },
    });
    if (!res.status) throw new Error("wrong password");
    window.top?.location.reload();
    return res.data.id;
  };

  const keyboard = () => {
    if (authVariant === "password")
      return (
        <InputForm
          borderless
          style={{ marginBottom: 22, marginTop: 16 }}
          onFinish={async (password) => {
            onChange?.(
              { value: false, progressScenario: false, pushStack: false },
              {
                dialogBlockType: "user",
                type: "text",
                text: password,
              }
            );

            try {
              const userId = await authPassword(phone as string, password);
              try {
                await onAuth(userId, phone as string);
              } catch {
                onChange?.(
                  { progressScenario: false, pushStack: false },
                  {
                    dialogBlockType: "bot",
                    type: "text",
                    text: i18n.t("authorize.failed"),
                  }
                );
              }
            } catch {
              onChange?.(
                { progressScenario: false, pushStack: false },
                {
                  dialogBlockType: "bot",
                  type: "text",
                  text: i18n.t("authorize.password.failed"),
                }
              );
            }
          }}
        >
          <Input.Password
            placeholder={i18n.t("placeholder.password")}
            className={styles.input}
          />
        </InputForm>
      );

    if (authVariant === "code")
      return (
        <>
          <Buttons
            mobile={mobile}
            items={[
              ...(userChecked && authServices
                ? [
                    {
                      name: i18n.t("authorize.password.button"),
                      onClick: async () => {
                        onChange?.(
                          { progressScenario: false, pushStack: false },
                          {
                            dialogBlockType: "user",
                            type: "text",
                            text: i18n.t("authorize.password.button"),
                          }
                        );
                        try {
                          const { hasPassword } = await frontendAjaxCall(
                            "auth/web/has-password",
                            { method: "GET", body: { phone } }
                          );
                          setUserChecked("userExist");
                          if (hasPassword) {
                            setAuthVariant("password");

                            onChange?.(
                              { progressScenario: false, pushStack: false },
                              {
                                dialogBlockType: "bot",
                                type: "text",
                                text: i18n.t("authorize.password.messageHasPassword"),
                              }
                            );
                          } else {
                            onChange?.(
                              { progressScenario: false, pushStack: false },
                              {
                                dialogBlockType: "bot",
                                type: "text",
                                text: i18n.t("authorize.password.messageNoPassword"),
                              }
                            );
                          }
                        } catch (e) {
                          setAuthVariant("password");
                          setUserChecked("noUser");

                          onChange?.(
                            { progressScenario: false, pushStack: false },
                            {
                              dialogBlockType: "bot",
                              type: "text",
                              text: i18n.t("authorize.password.messageNoUser"),
                            }
                          );
                        }
                      },
                    },
                  ]
                : []),
              {
                name: i18n.t("sendNewCodeSMS"),
                onClick: async () => {
                  onChange?.(
                    {
                      progressScenario: false,
                      pushStack: false,
                    },

                    {
                      dialogBlockType: "user",
                      type: "text",
                      text: i18n.t("sendNewCodeSMS"),
                    }
                  );
                  try {
                    await sendCode(phone as string, "sms");
                    onChange?.(
                      {
                        progressScenario: false,
                        pushStack: false,
                      },
                      {
                        dialogBlockType: "bot",
                        type: "text",
                        text: i18n.t("authorize.resendCodeSuccess", { phone }),
                      }
                    );
                  } catch (e) {
                    onChange?.(
                      {
                        progressScenario: false,
                        pushStack: false,
                      },
                      {
                        dialogBlockType: "bot",
                        type: "text",
                        text: i18n.t("authorize.failedToSendCode"),
                      }
                    );
                  }
                },
              },
            ]}
          />

          <InputForm
            borderless
            rules={[{ pattern: /\d+/, message: i18n.t("input.digitsOnly") }]}
            style={{ marginBottom: 22, marginTop: 16 }}
            onFinish={async (value) => {
              onChange?.(
                { value: false, progressScenario: false, pushStack: false },
                {
                  dialogBlockType: "user",
                  type: "text",
                  text: value,
                }
              );
              try {
                const userId = await verifyCode(phone as string, value);
                try {
                  await onAuth(userId, phone as string);
                } catch {
                  onChange?.(
                    { progressScenario: false, pushStack: false },
                    {
                      dialogBlockType: "bot",
                      type: "text",
                      text: i18n.t("authorize.failed"),
                    }
                  );
                }
              } catch {
                onChange?.(
                  { progressScenario: false, pushStack: false },
                  {
                    dialogBlockType: "bot",
                    type: "text",
                    text: i18n.t("incorrectCode"),
                  }
                );
              }
            }}
          >
            <Input
              placeholder={i18n.t("placeholder.authorize")}
              className={styles.input}
            />
          </InputForm>
        </>
      );

    return (
      <>
        {authServices && (
          <AuthServices
            gutter={[32, 0]}
            /* style={{ paddingBottom: 16 }} */
            justify="end"
          />
        )}
        <InputForm
          borderless
          rules={[
            {
              validator: async (_: any, value: string) => {
                value = value.startsWith("+") ? value : "+" + value;
                if (isPossiblePhoneNumber(value)) return;
                else throw new Error(i18n.t("input.impossiblePhoneNumber"));
              },
            },
          ]}
          style={{ marginBottom: 22, marginTop: 16 }}
          onFinish={async (value) => {
            const phone = [...value].filter((char) => char.match(/\d/)).join("");
            setPhone(phone);
            setAuthVariant("code");
            onChange?.(
              {
                value,
                path: "ctx.phone",
                progressScenario: false,
                pushStack: false,
              },

              {
                dialogBlockType: "user",
                type: "text",
                text: value,
              }
            );
            try {
              await sendCode(phone);
              onChange?.(
                { progressScenario: false, pushStack: false },
                {
                  dialogBlockType: "bot",
                  type: "text",
                  text: i18n.t("authorize.sendCodeSuccess", { phone }),
                }
              );
            } catch (e) {
              onChange?.(
                { progressScenario: false, pushStack: false },
                {
                  dialogBlockType: "bot",
                  type: "text",
                  text: i18n.t("authorize.failedToSendCode"),
                }
              );
            }
          }}
        >
          <ScenarioFormItem
            item={{
              type: "phone",
              required: true,
              placeholder: i18n.t("placeholder.phone"),
            }}
            className={styles.input}
          />
        </InputForm>
      </>
    );
  };

  return (
    <div className={styles.authorize}>
      {keyboard()}
      <DialogBoxFooter
        mode="default"
        onBack={onBack}
        contrastGrayscale={contrastGrayscale}
      />
    </div>
  );
};

export default Auth;
